import { useMutation } from "@tanstack/react-query";
import _cookies from "../../../shared/utils/_cookies";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";
export const requestExtraCourseEnrollment = async (data) => {
  const payload = {
    alunoid: data.studentId || _cookies.getItem("auth").user?.alunoid,
    email: _cookies.getItem("auth").user?.email,
    cursoid: data.cursoid,
    disciplinaid: data.disciplinaid,
  };

  const body = new FormData();

  body.append("dados", `${JSON.stringify([payload])}`);
  const res = await axios.middleware.post(
    "/aluno.asmx/Novo_Pedido_Matricula",
    body
  );
  return res;
};

export const useRequestCourseEnrollment = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: requestExtraCourseEnrollment,
    onSuccess: () => {
      createNotification({ type: "success", message: "Matrícula criada" });
    },
  });
};
